(function(window,$) {

	$('.app_question').each(function() {
		new Drawer($(this));
	});

	function Drawer(element) {

		$('button', element).on('click', function() {
			if ( element.hasClass('app_open') ) {
				element.removeClass('app_open');
			} else {
				element.addClass('app_open');
			}
		});

	}

})(window,jQuery);
